const cases = [
  { icon: "ri-government-line", title: "某国有大型商业银行", stat: "资产规模 38万亿元", desc: "通过空间数据驱动对公客户精准拓展，6个月新增有效对公客户1,240家，企业授信规模增长22%，对公存款平均余额提升18%。", color: "from-blue-500 to-indigo-500" },
  { icon: "ri-group-line", title: "某全国性股份制商业银行", stat: "零售客户 1.2亿户", desc: "零售拓客系统上线后，高净值客户识别精准度提升至91%，私行财富管理规模新增420亿元，零售客户NPS评分提升14个百分点。", color: "from-emerald-500 to-teal-400" },
  { icon: "ri-shield-check-line", title: "某省级城市商业银行", stat: "抵押贷款余额 2,600亿元", desc: "抵押贷款辅助系统将房产评估效率提升3倍，不良贷款率下降1.2个百分点，贷款审批周期从15天缩短至5天，客户满意度大幅提升。", color: "from-amber-500 to-orange-400" },
  { icon: "ri-map-pin-2-line", title: "某农村商业银行", stat: "服务区域覆盖 86个乡镇", desc: "网点选址优化模型帮助规划新增网点23个，选址科学性评分达到94分，新网点客户获取成本降低35%，运营首年实现盈亏平衡。", color: "from-violet-500 to-purple-400" },
];

export default function FSCasesV2() {
  return (
    <section className="py-20 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-xs font-semibold text-cyan-600 tracking-widest uppercase mb-2 block">Implementation Cases</span>
          <h2 className="text-3xl font-bold text-slate-800 mb-3">金融服务落地案例</h2>
          <p className="text-slate-500 text-sm max-w-xl mx-auto">已在国有大行、股份制银行、城商行、农商行等金融机构成功部署运营</p>
        </div>
        <div className="grid grid-cols-2 gap-6">
          {cases.map(c => (
            <div key={c.title} className="bg-slate-50 rounded-2xl p-6 border border-slate-100 hover:border-cyan-200 transition-all group">
              <div className="flex items-start gap-4">
                <div className={`w-14 h-14 rounded-2xl flex items-center justify-center bg-gradient-to-br ${c.color} flex-shrink-0 group-hover:scale-105 transition-transform`}>
                  <i className={`${c.icon} text-white text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3 mb-2">
                    <h3 className="text-slate-800 font-semibold text-lg">{c.title}</h3>
                    <span className="text-xs bg-white border border-slate-200 text-slate-500 px-2 py-0.5 rounded-full">{c.stat}</span>
                  </div>
                  <p className="text-slate-500 text-sm leading-relaxed">{c.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
